import React from 'react';
import { useTranslation } from 'localization';
import type { MarketplaceActivity, ActivityTone } from 'types/marketplace-activity';
import './MarketplaceActivityRowMolecule.scss';

export interface MarketplaceActivityRowMoleculeProps {
  activity: MarketplaceActivity;
  className?: string;
}

const TONE_ICON: Record<ActivityTone, string> = {
  success: 'pi-check-circle',
  info: 'pi-info-circle',
  warn: 'pi-exclamation-triangle',
};

const MarketplaceActivityRowMolecule: React.FC<MarketplaceActivityRowMoleculeProps> = ({
  activity,
  className = '',
}) => {
  const { t } = useTranslation();
  const icon = TONE_ICON[activity.tone] ?? 'pi-info-circle';

  const classes = [
    'marketplace-activity-row',
    `marketplace-activity-row--${activity.tone}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const formattedDate = activity.created_at
    ? new Date(activity.created_at).toLocaleString()
    : '';

  return (
    <div className={classes}>
      {/* Timeline line + icon */}
      <div className="marketplace-activity-row__timeline">
        <div className="marketplace-activity-row__timeline-line" />
        <i className={`pi ${icon} marketplace-activity-row__icon`} aria-hidden="true" />
      </div>

      {/* Content */}
      <div className="marketplace-activity-row__content">
        <div className="marketplace-activity-row__header">
          <span className="marketplace-activity-row__action">
            {t(`marketplace.activity.actions.${activity.action}`, {
              defaultValue: activity.action,
            })}
          </span>
        </div>

        <div className="marketplace-activity-row__metadata">
          {activity.actor_label && (
            <span className="marketplace-activity-row__actor">
              {activity.actor_label}
            </span>
          )}
          {activity.actor_label && activity.created_at && (
            <span className="marketplace-activity-row__sep">·</span>
          )}
          <time className="marketplace-activity-row__time" dateTime={String(activity.created_at)}>
            {formattedDate}
          </time>
        </div>
      </div>
    </div>
  );
};

MarketplaceActivityRowMolecule.displayName = 'MarketplaceActivityRowMolecule';

export default MarketplaceActivityRowMolecule;
